import { NewAddressUi } from '@/components/Buyer/BuyerProfile/DeliveryAddress/NewAddress/NewAddressUi';
import { BuyerAddressRequest } from '@/data/api/model/buyers/BuyersDto';

export function newAddressUiToBuyerAddressRequest(
  input: NewAddressUi
): BuyerAddressRequest {
  return {
    address_type: 'SHIPPING',
    zip_code: input.postalCode,
    colony: input.colonia,
    street: input.street,
    tag: input.addressTag,
    interior_number: input.internalNumber,
    exterior_number: input.externalNumber,
    default: 1,
  };
}
